import { CURRENT_INSTANCE } from '@lib/utils';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
}
const CustomLink = ({
  href,
  children,
}: {
  href?: string | undefined;
  children?: React.ReactNode;
}) => {
  if (!href) return <>{children}</>;
  if (href.startsWith('/')) {
    const path = CURRENT_INSTANCE.isDefault ? '' : `/instance/${CURRENT_INSTANCE.name}`;
    return <Link to={`${path}${href}`}>{children}</Link>;
  }
  return <Link to={href}>{children}</Link>;
};

const MarkdownRenderer = (props: MarkdownRendererProps) => {
  return (
    <div className="markdown-renderer whitespace-normal">
      <ReactMarkdown
        components={{
          a: ({ node, ...linkProps }) => <CustomLink {...linkProps} />,
          p: ({ children }: { children?: React.ReactNode }) => <p className="my-2">{children}</p>,
          ol: ({ children }: { children?: React.ReactNode }) => (
            <ol className="block list-decimal m-0 p-0 my-2 pl-5">{children}</ol>
          ),
          ul: ({ children }: { children?: React.ReactNode }) => (
            <ul className="block list-disc m-0 p-0 my-2 pl-5">{children}</ul>
          ),
        }}
        remarkPlugins={[remarkGfm]}
      >
        {props.content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
